import routeUtils from '~/utils/route_utils';

export default {
    queryParams: state => {
        return Object.assign({}, state.loans.params);
    },

    getAllIdsQueryParams: state => {
        return Object.assign({}, state.loans.params, {
            get_ids: 1
        });
    },

    defaultFilter: state => {
        if (state.loans.params.report_type === 'pipeline') {
            return state.default_pipeline_filter;
        } else if (state.loans.params.report_type === 'funded') {
            return state.default_funded_filter;
        } else {
            return null;
        }
    },

    hasActiveFilter: (state, getters) => {
        const excluded = ['page', 'page_size', 'sort', 'search', 'report_type', 'order_column', 'order_dir'];
        const comparison = getters.defaultFilter || {};

        return !routeUtils.compareQueries(comparison, state.loans.params, excluded);
    }
}